import { RoutePointsResponse } from './routingTypes';
import { VehicleRoutes } from './routingTypes';

interface Props {
  longestDrivenDayEnabled: boolean;
  routePointsResponse: RoutePointsResponse;
}

const getVehicleRoutes = ({ longestDrivenDayEnabled, routePointsResponse }: Props): VehicleRoutes | undefined => {
  return {
    ...routePointsResponse,
    UpdatedAt: new Date().toISOString(),
    LongestDrivenDayEnabled: longestDrivenDayEnabled,
  };
};

export default getVehicleRoutes;
